"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var SwitchButton = /*#__PURE__*/function (_Component) {
  _inherits(SwitchButton, _Component);

  function SwitchButton(props) {
    var _this;

    _classCallCheck(this, SwitchButton);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SwitchButton).call(this, props));
    _this.state = {
      isChecked: props.isChecked
    };
    _this._handleChange = _this._handleChange.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(SwitchButton, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setState({
        isChecked: this.props.isChecked
      });
    }
  }, {
    key: "_handleChange",
    value: function _handleChange() {
      var _this2 = this;

      var val = !this.state.isChecked;
      this.setState({
        isChecked: val
      }, function () {
        _this2.props.onChange(val);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var text = null;

      if (this.props.text) {
        text = _react["default"].createElement("p", {
          style: {
            paddingRight: 10,
            fontSize: 12,
            fontWeight: 'lighter',
            margin: 0
          }
        }, this.state.isChecked ? 'ON' : 'OFF');
      }

      return _react["default"].createElement("div", {
        className: "switch-container"
      }, text, _react["default"].createElement("label", {
        style: {
          margin: 0,
          display: 'block'
        }
      }, _react["default"].createElement("input", {
        ref: "switch",
        checked: this.state.isChecked,
        onChange: this._handleChange,
        className: "switch",
        type: "checkbox"
      }), _react["default"].createElement("div", null, _react["default"].createElement("span", {
        className: "icon icon-toolbar grid-view"
      }), _react["default"].createElement("span", {
        className: "icon icon-toolbar ticket-view"
      }), _react["default"].createElement("div", null))));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var stateChange = {};

      if (typeof props.isChecked != 'undefined') {
        stateChange.isChecked = props.isChecked;
      }

      return stateChange;
    }
  }]);

  return SwitchButton;
}(_react.Component);

exports["default"] = SwitchButton;

_defineProperty(SwitchButton, "defaultProps", void 0);

SwitchButton.defaultProps = {
  onChange: function onChange() {}
};